/*global ymaps*/

import React from 'react';
import { render } from 'react-dom';
import defineLayerWMS from './defineLayerWMS';
import * as constants from './constants';
import { AppConfig } from './appConfig';

ymaps.ready(async () => {
    defineLayerWMS();
    const yandexModules = await ymaps.modules.require(['LayerWMS', "WMSGeoJsonCollection"]);
    if (yandexModules[0]) ymaps.LayerWMS = yandexModules[0];
    if (yandexModules[1]) ymaps.WMSGeoJsonCollection = yandexModules[1];

    render(
        <AppConfig />,
        document.getElementById(constants.APP_CONTAINER_ID)
    );
})
